export const coveredProductsRowOptions = [
  { label: 'Edit', value: 'Edit', callback: 'onRowEdit' },
  { label: 'Remove', value: 'Remove', callback: 'onClickDelete' },
  { label: 'History', value: 'History', callback: 'onViewHistory' }
];

export const coveredProductsHeaderOptions = [
  { label: 'Add', value: 'Add', callback: 'onClickAdd' }
];
